export const HEADERS: TableHeader[] = [
	{
		label: 'Name',
		key: 'NAME',
		classNames: "w-[400px] max-w-[400px]"
	},
	{
		label: 'Club Admin',
		key: 'ADMIN',
	},
	{
		label: 'Status',
		key: 'STATUS',
	},
	{
		label: 'Created',
		key: 'CREATED',
	},
	{
		label: 'Action',
		key: 'ACTION',
	},
];


export const OPTION_FILTER_STYLE = {
	true: {
		button: 'bg-blue-light text-white',
		pill: 'bg-blue-lighter',
	},
	false: {
		button: 'text-grey-dark',
		pill: 'bg-grey-subtle',
	},
};

export const FILTER = {
	ALL: {
		id: 'ALL',
		name: 'Semua',
		total: 0,
	},
	ACTIVE: {
		id: 'ACTIVE',
		name: 'Active',
		total: 0,
	},
	PENDING: {
		id: 'PENDING',
		name: 'Pending',
		total: 0,
	},
	INACTIVE: {
		id: 'INACTIVE',
		name: 'Inactive',
		total: 0,
	},
	REJECTED: {
		id: 'REJECTED',
		name: 'Rejected',
		total: 0,
	},
};

export const FILTER_KEYS = Object.keys(FILTER);

export const TOTAL_OPTION_FITLER = FILTER_KEYS.length;